import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { listenForEvent } from 'irmlib/common'
import { useFormPageHandler, useMergeState } from '../../../../irmlib/src/hooks'
import { FlexByRow, XDivider, YDivider, HalfScreen } from '../../../../irmlib/src/styles'
import { MainRouteSubRoutePage } from '../../../AppControl/RoutePage'
import { Select, TextField, ClearButton, SaveButton, DateTime, Autocomplete } from '../../../../irmlib/src/components/FormControls'
import * as constants from '../../../../irmlib/src/common/constants'
import * as gdeTrancactions from '../../../../services/firestore/gdeTransactions'
import { clearBusy, LocalToast, setBusy } from '../../../../irmlib/src/containers'
import { Label } from '../../../../irmlib/src/components/Controls'
import TemplateSearchTable from './templateSearchTable'
import { getUser } from '../../../../redux/global'
import { useHistory } from 'react-router'
import { sideBarEventUrlClicked } from '../../../../common/constants'
import * as routePaths from '../../../../navigation/routePaths'
import { translate } from 'irmlib/multilanguage'
import { useTranslation } from 'react-i18next'

const useStandardTemplate = 'useStandarrdTemplate'

const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }

const TemplateSearch = () => {
  const { t } = useTranslation()
  const refLocalBusyCursor = useRef(null)

 
  const VerticalDivider = () =>
    <YDivider height='20px' />

     
  const resetAll = () => {
    arrRefs[SELECT_COUNTRY].current.setValue('us') 
    arrRefs[SELECT_WMS].current.setValue('SKP') 
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setValue('')
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setValue('')
    arrRefs[DATECREATEDFROM].current.setValue(constants.defaultSelect)
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setValue('')
    arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(constants.defaultSelect)
    arrRefs[SELECT_TEMPLATE_NAME].current.setValue(constants.defaultSelect)
    arrRefs[DATECREATEDTO].current.setValue(constants.defaultSelect)
  }


  const Buttons = props =>
    <>
      <ClearButton id={'templateSearch_button_reset'} clearLabel='forms.Reset' arrRefs={props.arrRefs} onClick={resetAll}/>
      <XDivider width='10px' />
      <SaveButton id={'templateSearch_button_search'} saveLabel='buttons.search' feedBack arrRefs={props.arrRefs} postService={Filterdata} />
    </>

  Buttons.propTypes = {
    arrRefs: PropTypes.array,
  }

  const getService = async () => {
    const getObject = {
    }
    return Promise.resolve(getObject)
  }

  const SELECT_COUNTRY = 0
  const SELECT_WMS = 1
  const DATECREATEDFROM = 2
  const DATECREATEDTO = 3
  const SELECT_ACOUNT_LEVEL1 = 4
  const SELECT_ACOUNT_LEVEL2 = 5
  const SELECT_ACOUNT_LEVEL3 = 6
  const SELECT_TEMPLATE_TYPE = 7
  const SELECT_TEMPLATE_NAME = 8
  const FIELD_CUSTOM_TEMPLATE_NAME = 9


  const initialSate = {
    showTable: false,
    showEmpty: false,
    showSearch: true,
    countries: [],
    templates: [],
    templatesForSelect: [],
    workerDetails: [],
    wmsList: [],
    templateTypeList: [],
    selectedWms: '',
    selectedTemplate: '',
    disircts: [],
    templateTypeNames: []
  }

  const serachInit = { 
    country: constants.defaultSelect,
    wms: constants.defaultSelect,
    accountLevel1: constants.defaultForAccountLevel.toUpperCase(),
    accountLevel2: constants.defaultForAccountLevel.toUpperCase(),
    accountLevel3: constants.defaultForAccountLevel.toUpperCase(),
    dateCreatedFrom: constants.defaultSelect,
    templateType: constants.defaultSelect,
    templateName: constants.defaultSelect,
    dateCreatedTo: constants.defaultSelect
  }
 
  const [searchValue, setSearchValue] = useState(serachInit)


  const formTemplate = [
    {
      label: ('Search.Country'),
      fieldKey: 'country',
      defaultValue: searchValue.country,
      isRequired: false
    },
    {
      label: ('Search.Associatedwmssystem'),
      fieldKey: 'wms',
      defaultValue: searchValue.wms,
      isRequired: false
    },
    {
      label: ('demo.CreationDateFrom'),
      fieldKey: 'obj.obj1.date',
      defaultValue: searchValue.dateCreatedFrom,
      isRequired: false
    },
    {
      label: ('demo.CreationDateTo'),
      fieldKey: 'obj.obj1.date',
      defaultValue: searchValue.dateCreatedTo,
      isRequired: false
    },
    {
      label: ('Search.AccountLevel/Customer'),
      fieldKey: 'accountLevel1',
      defaultValue: searchValue.accountLevel1,
      isRequired: false
    },
    {
      label: ('templates.accountLevelTwo'),
      fieldKey: 'accountLevel2',
      defaultValue: searchValue.accountLevel2,
      isRequired: false
    },
    {
      label: ('templates.accountLevelThree'),
      fieldKey: 'accountLevel3',
      defaultValue: searchValue.accountLevel3,
      isRequired: false
    },
    {
      label: ('Search.TemplateType'),
      fieldKey: 'deType',
      defaultValue: searchValue.templateType,
      isRequired: false
    },
    {
      label: ('Search.TemplateName'),
      fieldKey: 'templateName',
      defaultValue: searchValue.templateName,
      isRequired: false
    },
    // {
    //   label: 'Search.TemplateName',
    //   fieldKey: 'templateName',
    //   defaultValue: searchValue.templateName,
    //   isRequired: false
    // },
  ]


  const [arrRefs, data] = useFormPageHandler({ 
    formTemplate, 
    service: getService, 
    busyOverride: refLocalBusyCursor, 
  })
  const [state, setState, getState] = useMergeState(initialSate)
  const [searchData, setSearchData] = useState(serachInit)

  useEffect(() => {
  }, [searchValue])

  const history = useHistory()

  const refLocalToast = useRef(null)
  const ContentForDialogBox = (props) =>
    <>
      <Label>messages.saveNewTemplateMessage</Label>
      <VerticalDivider />
      <TextField
        data={data}
        fieldTemplate={formTemplate[FIELD_CUSTOM_TEMPLATE_NAME]}
        ref={arrRefs[FIELD_CUSTOM_TEMPLATE_NAME]}
        noTranslateStartString
        startString={props.namePrefix()}
      />
    </>

  ContentForDialogBox.propTypes = {
    namePrefix: PropTypes.func
  }
  const customerId = getUser().workerId

  
  useEffect(() => {
    getTemplateTypes()
    getCountries()
    getWorkerDetails(customerId)
    const remove = listenForEvent(sideBarEventUrlClicked, ({ detail }) => {
      if (detail === routePaths.templateSearch) {
        setState({ showTable: false, showEmpty: false })
        // Have to do this because react does not clear out the table nicely.
        setTimeout(() => setState({ showSearch: true }), 1)
      }
    })
    return () => remove()
  }, [])

  useEffect(() => {
    if (history.location.state && history.location.state.state) {
      setSearchData(history.location.state.state.detail)
      setState({ showTable: true, showSearch: false, showEmpty: false })
    }
    
    history.replace()
    // history.replace()
  }, [history.location.state])


  const getCountries = async () => {
    const collection = await gdeTrancactions.getCountries()
    const countryList = [defaultSelectOption]
    collection.forEach((doc) => {
      countryList.push({ value: doc.id, label: `${doc.id}-${doc.data().countryName}` })
    })
    setState({ countries: countryList })
  }

  const getWorkerDetails = async (userId) => {
    const workerDetails = await gdeTrancactions.getWorkerDetails(userId)    
    setState({ workerDetails: workerDetails })
    if (getState().showSearch === true) {
      arrRefs[SELECT_COUNTRY].current.setValue(getState().workerDetails.countryCode)
      arrRefs[SELECT_WMS].current.setValue('SKP')
    }
  }

  const Filterdata = () => {
    const dataFilter = {
      country: arrRefs[SELECT_COUNTRY].current.getValue(), 
      wms: arrRefs[SELECT_WMS].current.getValue(), 
      accountLevel1: arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue().toUpperCase(),
      accountLevel2: arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue().toUpperCase(),
      dateCreatedFrom: arrRefs[DATECREATEDFROM].current.getValue(), 
      accountLevel3: arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue().toUpperCase(),
      templateType: arrRefs[SELECT_TEMPLATE_TYPE].current.getValue(),
      templateName: arrRefs[SELECT_TEMPLATE_NAME].current.getValue(),
      dateCreatedTo: arrRefs[DATECREATEDTO].current.getValue()
    }
    setSearchData(dataFilter)
    setState({ showTable: true, showSearch: false, showEmpty: false })
    history.replace()
  }
  
  const getWms = async () => {
    const wmsForList = [defaultSelectOption]
    wmsForList.push({ value: 'SKP', label: 'SKP' })
    setState({ wmsList: wmsForList })
  }

  const getTemplateTypes = async () => {
    const collection = await gdeTrancactions.getTemplateTypesForWms('SKP')
    const templateTypes = [defaultSelectOption]
    collection.forEach((doc) => {
      if (doc.data()?.assetType !== 'BOX TRANSMITTAL') {
        templateTypes.push({ value: doc.data().dataEntryType, label: doc.data().dataEntryType })
      }
    })
    setState({ templateTypeList: templateTypes })
  }

  // backend data conversion for template types
  state.templateTypeList.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`templateTypeObj.${element.value}`)
    }
  })

  const onChangeTemplateType = (value) => {
    if (value !== undefined) {
      getTemplatesForTemplateType(value, 'SKP')
    }
  }
  const onChangeCustomer = (value) => {
    if (value !== undefined) {
      arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(constants.defaultSelect)
      arrRefs[SELECT_TEMPLATE_NAME].current.setValue(constants.defaultSelect)
    }
  }

  const getTemplatesForTemplateType = async (templateType) => {
    setBusy()
    // const collection = await gdeTrancactions.getTemplatesForDeType(templateType, wms)
    // const templateList = [defaultSelectOption]
    const accLevel1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()       
    const collection = await gdeTrancactions.getTemplates(templateType, accLevel1)
    const useStandardTemplateOption = { value: useStandardTemplate, label: translate('templates.useStandardTemplate') }
    const templateList = [defaultSelectOption, useStandardTemplateOption]

    const templateDetailsList = {}
    collection.forEach((doc) => {
      templateList.push({ value: doc.id, label: doc.id })
      templateDetailsList[doc.id] = doc
    })
    setState({ templates: templateDetailsList, templatesForSelect: templateList, selectedTemplate: '' })
    clearBusy()
  }

  const onChangeCountry = (value) => {
    if (value !== undefined && value !== constants.defaultSelect) {
      getWms(value)
    }
  }
  

  const postService = async postObject => {
    return Promise.resolve()
  }

  const getPageData = (value) => {
    return value
  }

  const filter = (value) => {   
    setSearchValue(value)
    setSearchData(serachInit)
    setState({
      showTable: false,
      showSearch: true,
      showEmpty: false
    })
  }
  
  const dataRecieved = (value) => {
    return value
  }
  return (
    <>
      {getState().showTable
        ? <>
          <VerticalDivider />
          <TemplateSearchTable onClickFilter={filter} dataSearch={searchData} dataLoad={getPageData} dataRecieved={dataRecieved}/>
          
        </>
        : null}
      {getState().showSearch
        ? <MainRouteSubRoutePage
            mainTitle="routeTitles.templateManagement"
            subTitle="routeTitles.searchTemplate"
            buttons={<Buttons arrRefs={arrRefs} postService={postService} />}
            centerButtons
          >
          <VerticalDivider />
          <VerticalDivider />
          <FlexByRow>
            <LocalToast ref={refLocalToast} />
            <HalfScreen>
              <Select
                id={'templateSearch_country'}
                onChange={onChangeCountry}
                data={data}
                items={state.countries}
                fieldTemplate={formTemplate[SELECT_COUNTRY]}
                ref={arrRefs[SELECT_COUNTRY]}
                noTranslateItems
                noTranslate={true}
              />
              <VerticalDivider />
              <VerticalDivider />

              <Select
                id={'templateSearch_wms'}
                onChange={getWms}
                data={data}
                items={state.wmsList}
                fieldTemplate={formTemplate[SELECT_WMS]}
                ref={arrRefs[SELECT_WMS]}
                noTranslateItems
                noTranslate={true}
              />
              <VerticalDivider />
              <VerticalDivider />
              <TextField
                id={'templateSearch_customer'}
                onChange={onChangeCustomer}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
                noTranslate={true}
              />
              <VerticalDivider />
              <VerticalDivider />
              <TextField
                id={'templateSearch_division'}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
                noTranslate={true}
              />
              <VerticalDivider />
           
            </HalfScreen>
            <VerticalDivider />
            <VerticalDivider />
            <XDivider width="50px" />
            <HalfScreen>
              <TextField
                id={'templateSearch_department'}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
                noTranslate={true}
              />
              <VerticalDivider />
              <VerticalDivider />
              <Autocomplete
                data={data}
                id={'templateSearch_templateType'}
                options={state.templateTypeList}
                fieldTemplate={formTemplate[SELECT_TEMPLATE_TYPE]}
                ref={arrRefs[SELECT_TEMPLATE_TYPE]}
                onChange={onChangeTemplateType}
                noTranslateItems
                noTranslate={true}
              />
              <VerticalDivider />
              <VerticalDivider />
              <Autocomplete
                id={'templateSearch_templateName'}
                data={data}
                options={state.templatesForSelect}
                fieldTemplate={formTemplate[SELECT_TEMPLATE_NAME]}
                ref={arrRefs[SELECT_TEMPLATE_NAME]}
                noTranslateItems
                noTranslate={true}
              />
              <VerticalDivider />
              <VerticalDivider />
              <FlexByRow>
                <HalfScreen>
                  <DateTime
                    id={'templateSearch_dateCreatedFrom'}
                    data={data}
                    fieldTemplate={formTemplate[DATECREATEDFROM]}
                    ref={arrRefs[DATECREATEDFROM]}
                    type="date"
                    noTranslate={true}
                  />
                </HalfScreen>
                <XDivider width="50px" />
                <HalfScreen>
                  <DateTime
                    id={'templateSearch_dateCreatedTo'}
                    data={data}
                    fieldTemplate={formTemplate[DATECREATEDTO]}
                    ref={arrRefs[DATECREATEDTO]}
                    type="date"
                    noTranslate={true}
                  />
                </HalfScreen>
              </FlexByRow>
            </HalfScreen>
          </FlexByRow>
          <VerticalDivider />
        </MainRouteSubRoutePage> 
        : null
        
        }      
    </>
  )
}

export default TemplateSearch
